module.exports = __webpack_public_path__ + "images/emoji/pig.a62edd5dfc05aaec5a90.png";